import * as React from 'react'
import { useCallback, useEffect } from 'react'
import { NoteCode } from '@user/components/Notes/typings'
import { ActionModalForm } from '@sales-center/components'
import { useFormikContext } from 'formik'
import { BulkAddNoteFormType } from './typings'
import Stack from '@mui/material/Stack'
import { NoteFormFieldElements } from '@user/components/Notes/AddNoteDrawer/AddNoteForm/NoteFormElements'

type Props = {
  noteCodes: NoteCode[]
  externalLocationId: string | undefined
}

export function BulkAddNoteFormFields(props: Props) {
  const { noteCodes, externalLocationId } = props

  const { submitForm, errors, touched, values, setFieldValue, isSubmitting } =
    useFormikContext<BulkAddNoteFormType>()

  const onSave = useCallback(() => {
    submitForm()
  }, [submitForm])

  useEffect(() => {
    if (values.addToPestPacLocation == false) {
      setFieldValue('noteCode', '')
    }
  }, [values.addToPestPacLocation, setFieldValue])

  return (
    <ActionModalForm
      disableSave={isSubmitting}
      onSave={onSave}
      primaryBtnLabel="Save"
    >
      <Stack width="100%">
        <NoteFormFieldElements
          serviceOptions={[]}
          externalLocationId={externalLocationId}
          noteCodes={noteCodes}
          noteFieldName="Note"
          noteFieldHelp={
            errors.Note && touched.Note
              ? errors.Note
              : `${values.Note.length.toLocaleString()}/5,000`
          }
          noteFieldError={errors.Note && touched.Note}
          toggleName="addToPestPacLocation"
          toggleValue={values.addToPestPacLocation}
          requiredOtherFields={Boolean(values.addToPestPacLocation)}
          noteCodeFieldName="noteCode"
          noteCodeHelp={
            errors.noteCode && touched.noteCode ? errors.noteCode : ''
          }
          noteCodeError={errors.noteCode && touched.noteCode}
          noteCode={values.noteCode}
          setFieldValue={setFieldValue}
        />
      </Stack>
    </ActionModalForm>
  )
}
